import React from 'react';
import PluginsScreen from '@/components/Plugins/PluginsScreen';
export default function PluginsRoute() { return <PluginsScreen />; }
